export const validateNumber = (value) => new RegExp('^[0-9]*$').test(value);
// eslint-disable-next-line
export const validateLat = (value) => /^-?\d*\.?\d{0,10}$/g.test(value);
// eslint-disable-next-line
export const validateLong = (value) => /^-?\d*\.?\d{0,10}$/g.test(value);
// eslint-disable-next-line
export const validateLongLat = (value) => new RegExp('^[+-]?[0-9]{1,9}(?:\.[0-9]{1,10})?$').test(value);
// eslint-disable-next-line
export const validateAlphanumeric = value => new RegExp('^[a-zA-Z0-9]+$').test(value);
// eslint-disable-next-line
export const validateUrlPath = value => new RegExp('(http[s]?:\/\/)?([^\/\s]+\/)(.*)').test(value);
// eslint-disable-next-line
export const validatePassword = value => new RegExp(`^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{12,})`).test(value);
